import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { srBodyTemplate, CommonBodyForTable, commonFormDialogFooter } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Dialog } from "primereact/dialog";
import { CommonForDetails } from "../CRM/Leads";
import { Toast } from "primereact/toast";
import { failureToast, successToast } from "../Common/CommonFunctions";
const saved = localStorage.getItem("user");

// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * OrderDetails component to display a list of OrderDetails in a data table.
 * It fetches the OrderDetails data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the OrderDetails based on their names or other attributes.
 */
export const OrderDetails = (props) => {
    const [ordersList, setOrderDetailsList] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);


    useEffect(() => {
        getOrderDetails(props.order)
    }, [])

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Order Detail</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                </div>
            </span>
        </div>
    )

    /**
     * Function to fetch OrderDetails data from the API
     * and update the state with the fetched data.
     */
    const getOrderDetails = async (data) => {
        setLoading(true)
        const response = await apiServices.getGSFOrderComboDetails(data)   // Assuming this API returns the OrderDetails data
        if (response?.data?.response_obj && response.data.response_obj.combos.length > 0) {
            data = response.data.response_obj.combos
            // setOrderDetailsList(response.data.response_obj[0].combos)
            setOrderDetailsList(data.map((val) => {
                return {
                    ...val,
                    total: val.price * val.quantity
                    // Add any additional properties or transformations here
                };
            }));
        } else {
            setOrderDetailsList([])
        }
        setLoading(false)
    }

    const openOrderDetails = (rowData) => {
        // setSelectedOrder(rowData);
        // setOrderDetailsDialog(true);
    }

    /** * Function to render the action buttons for each row in the data table.
     * It includes Edit and View buttons with appropriate styles and actions.
     * @param {Object} rowData - The data of the current row.
     * @returns JSX element containing action buttons.
     */
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <Button icon="pi pi-eye" title='View Details' className="p-button-rounded p-button-info p-mx-2" aria-label="View Details" onClick={() => { openOrderDetails(rowData) }} />
                    {/* <Button icon="pi pi-pencil" title='Edit' className="p-button-rounded p-button-warning p-mx-1" aria-label="Edit" id={rowData.id} onClick={() => updateSalesMember(rowData)} /> */}
                </div>
            </>
        );
    }


    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center" />
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                        value={ordersList} dataKey="id" exportFilename={`Orders_details`}
                                        loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header} >
                                        <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }} exportable={false}></Column>
                                        {/* <Column field="_id" header="Product ID" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={false}></Column> */}
                                        <Column field="product_name" header="Product Name" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={false}></Column>
                                        <Column field="quantity" header="Quantity" body={CommonBodyForTable} style={{ width: '1rem' }} exportable={false}></Column>
                                        <Column field="price" header="Razorpay Amount" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={false}></Column>
                                        <Column field="total" header="Total" body={CommonBodyForTable} style={{ width: '1rem' }} exportable={false}></Column>
                                        {/* <Column field="zoho_id" header="Zoho ID" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={false}></Column> */}
                                        {/* <Column field="action" header="Actions" body={actionBodyTemplate} style={{ width: '2rem' }}></Column> */}
                                    </DataTable>
                                </>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}